import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["email", "feedback", "button"]

  connect() {
    this.form = this.element
    this.form.addEventListener("submit", this.submit.bind(this))
  }

  async submit(event) {
    event.preventDefault()

    const email = this.form.querySelector("[name='email']").value
    const feedback = this.form.querySelector(".newsletter-feedback")
    const button = this.form.querySelector("button[type='submit']")
    const token = this.form.querySelector("[name='authenticity_token']").value

    button.disabled = true
    button.textContent = "..."

    try {
      const response = await fetch("/newsletter", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": token
        },
        body: JSON.stringify({ email })
      })

      const data = await response.json()

      feedback.classList.remove("d-none", "newsletter-error", "newsletter-success")

      if (response.ok) {
        feedback.classList.add("newsletter-success")
        feedback.textContent = data.message
        this.form.querySelector("[name='email']").value = ""
        button.textContent = "✓"
        // Sur la page dédiée, cacher le formulaire et afficher le succès
        const inputGroup = this.form.querySelector(".input-group, .mb-3")
        const submitGroup = this.form.querySelector(".d-grid")
        if (submitGroup) {
          inputGroup && (inputGroup.style.display = "none")
          submitGroup.style.display = "none"
        }
      } else {
        feedback.classList.add("newsletter-error")
        feedback.textContent = data.error
        button.disabled = false
        button.textContent = "S'inscrire"
      }
    } catch {
      feedback.classList.remove("d-none")
      feedback.classList.add("newsletter-error")
      feedback.textContent = "Une erreur est survenue. Veuillez réessayer."
      button.disabled = false
      button.textContent = "S'inscrire"
    }
  }
}
